/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _config = require('../config');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Signin = function () {
    function Signin(_ref) {
        var actHashId = _ref.actHashId;
        (0, _classCallCheck3["default"])(this, Signin);

        _scope.Feature.EventBus(this);

        this.actHashId = actHashId;
        this._rop();
        this._msgbusDestroy();
    }

    (0, _createClass3["default"])(Signin, [{
        key: '_rop',
        value: function _rop() {
            var _this = this;

            this.unsubComment = nats.on('mudu.comments.' + this.actHashId, function (dataStr) {
                var _JSON$parse = JSON.parse(dataStr),
                    action = _JSON$parse.action,
                    service_type = _JSON$parse.service_type,
                    content = _JSON$parse.content;

                if (service_type === 'sign') {
                    if (action === 'config') {
                        _this.Get();
                    } else if (action === 'close') {
                        var hash_id = content.hash_id,
                            is_open = content.is_open,
                            is_forced = content.is_forced,
                            start_at = content.start_at,
                            end_at = content.end_at,
                            now_time = content.now_time;

                        var res = {
                            id: hash_id,
                            is_open: is_open,
                            is_forced: is_forced,
                            is_sign: is_open,
                            start_time: start_at,
                            end_time: end_at,
                            server_time: now_time
                        };
                        var response = {
                            errcode: 1000,
                            msg: 'ok',
                            data: res
                        };
                        _scope.MsgBus.Pub('Signin.Close', (0, _stringify2["default"])(response));
                    }
                }
            });
        }
    }, {
        key: '_msgbusDestroy',
        value: function _msgbusDestroy() {
            var _this2 = this;

            this.destroyKey = _scope.MsgBus.Sub('Destroy', function () {
                // rop.Remove('mudu.comments.' + this.actHashId);
                _this2.unsubComment();

                _scope.MsgBus.UnSub(_this2.destroyKey);
            });
        }
    }, {
        key: 'UnSubSigninTopic',
        value: function UnSubSigninTopic() {
            // rop.Remove('mudu.comments.' + this.actHashId);
            this.unsubComment();
        }
        /**
        * 初始化获取签到配置 
        */

    }, {
        key: 'Get',
        value: function Get(callback) {
            try {
                var url = _config.API_DOMAIN_V2 + '/v2/watch/' + this.actHashId + '/interact/signup/view/config';
                Fetcher.Get(url, function (data) {
                    data = JSON.parse(data);
                    // console.log(data,'----api');
                    if (data.errcode === 1000) {
                        var res = (0, _extends3["default"])({}, data.data, { is_sign: data.is_sign });
                        var response = {
                            errcode: data.errcode,
                            msg: data.msg,
                            data: res
                        };
                        _scope.MsgBus.Pub('Signin.Config', (0, _stringify2["default"])(response));
                        callback && callback((0, _stringify2["default"])(response));
                    }
                }, _scope.DB.Get('requestHeader').session);
            } catch (e) {
                var res = { 'errcode': -1, msg: '获取签到配置,稍后再试!' };
                callback && callback((0, _stringify2["default"])(res));
            }
        }
        /**
        * 签到动作
        */

    }, {
        key: 'Send',
        value: function Send(signId, callback) {
            try {
                var url = _config.API_DOMAIN_V2 + '/v2/watch/' + this.actHashId + '/interact/signup/watch/sign?id=' + signId;
                Fetcher.Post(url, {}, function (data) {
                    data = JSON.parse(data);
                    // console.log(data,'---send---');
                    if (data.errcode === 1000) {
                        _scope.MsgBus.Pub('Signin.Result', (0, _stringify2["default"])(data));
                        callback && callback((0, _stringify2["default"])(data));
                        return;
                    }
                    _scope.MsgBus.Pub('Signin.Result', (0, _stringify2["default"])(data));
                }, (0, _extends3["default"])({ 'Content-Type': 'application/x-www-form-urlencoded' }, _scope.DB.Get('requestHeader').session));
            } catch (e) {
                var res = { 'errcode': -1, msg: '签到失败,稍后再试!' };
                callback && callback((0, _stringify2["default"])(res));
            }
        }

        // 签到签 要登陆（使用身份赋予获取用户登陆信息）

    }, {
        key: 'Assign',
        value: function Assign() {
            (0, _jquery2["default"])('#assign-username-btn').on('click', function () {
                // const username = $('#assign-username').val();
                // Mudu.Room.User.Assign(username || '新身份websdk', 'https://myun-hw-s3.myun.tv/melj80jz/lg4xz3x2/IMG_2839.jpg', String(Date.now()), user => {
                //     // console.log('user assign cb:', user);
                // });
            });
        }
    }]);
    return Signin;
}();

module.exports = Signin;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/Signin.js
 ** module id = 179
 ** module chunks = 1
 **/